import MDBox from "components/MDBox";
import Grid from "@mui/material/Grid";
import MDInput from "components/MDInput";
import CommonSelectWithoutNoneOption from "components/CommonSelect/selectWithoutNoneOption";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import { useCallback, useEffect, useState } from "react";
import { cantonsByProvince } from "rest/requests";
import { parroquiasByCanton } from "rest/requests";
import { provinces } from "rest/requests";
import { updateStore } from "rest/requests";
import Alert from "@mui/material/Alert";
import { addStore } from "rest/requests";

const edit = (
  id,
  code,
  identifier,
  businessName,
  areaName,
  legalRepresentative,
  technicalRepresentative,
  address,
  reference,
  idParish,
  idCanton,
  parish,
  setResultOk,
  setResultError
) => {
  let data = {
    id: id,
    parish: {
      createdDate: parish.createdDate,
      modifiedDate: parish.modifiedDate,
      idParish: idParish,
      cantonId: idCanton,
      name: parish.name,
      code: parish.code,
      active: parish.active,
    },
    parishId: idParish,
    code: code,
    identifier: identifier,
    businessName: businessName,
    areaName: areaName,
    legalRepresentative: legalRepresentative,
    technicalRepresentative: technicalRepresentative,
    address: address,
    reference: reference,
  };

  try {
    updateStore(id, data).then(
      function (value) {
        console.log(value);
        setResultOk(true);
      },
      function (error) {
        console.log(error);
        setResultError(true);
      }
    );

    //console.log("result: ", result);
  } catch (exc) {
    console.log("Error: ", exc);
  }
};

const add = (
  code,
  identifier,
  businessName,
  areaName,
  legalRepresentative,
  technicalRepresentative,
  address,
  reference,
  idParish,
  idCanton,
  parishCreatedDate,
  parishModifiedDate,
  parishName,
  parishCode,
  setResultOk,
  setResultError
) => {
  let data = {
    parish: {
      createdDate: parishCreatedDate,
      modifiedDate: parishModifiedDate,
      idParish: idParish,
      cantonId: idCanton,
      name: parishName,
      code: parishCode,
      active: true,
    },
    parishId: idParish,
    code: code,
    identifier: identifier,
    businessName: businessName,
    areaName: areaName,
    legalRepresentative: legalRepresentative,
    technicalRepresentative: technicalRepresentative,
    address: address,
    reference: reference,
  };

  try {
    addStore(data).then(
      function (value) {
        console.log(value);
        setResultOk(true);
      },
      function (error) {
        console.log(error);
        setResultError(true);
      }
    );

    //console.log("result: ", result);
  } catch (exc) {
    console.log("Error: ", exc);
  }
};

function HandleWarehouse({ elementToEdit, setIsHandlingWarehouse }) {
  const [code, setCode] = useState(elementToEdit ? elementToEdit.code : "");
  const [identifier, setIdentifier] = useState(elementToEdit ? elementToEdit.identifier : "");
  const [businessName, setBusinessName] = useState(elementToEdit ? elementToEdit.businessName : "");
  const [areaName, setAreaName] = useState(elementToEdit ? elementToEdit.areaName : "");
  const [legalRepresentative, setLegalRepresentative] = useState(
    elementToEdit ? elementToEdit.legalRepresentative : ""
  );
  const [technicalRepresentative, setTechnicalRepresentative] = useState(
    elementToEdit ? elementToEdit.technicalRepresentative : ""
  );
  const [address, setAddress] = useState(elementToEdit ? elementToEdit.address : "");
  const [reference, setReference] = useState(elementToEdit ? elementToEdit.reference : "");

  const [selectedProvinceEdit, setSelectedProvinceEdit] = useState(
    elementToEdit ? elementToEdit.parish.canton.province.idProvince : ""
  );
  const [selectedCantonEdit, setSelectedCantonEdit] = useState(
    elementToEdit ? elementToEdit.parish.canton.idCanton : ""
  );
  const [selectedParroquiaEdit, setSelectedParroquiaEdit] = useState(
    elementToEdit ? elementToEdit.parish.idParish : ""
  );

  const [provincesList, setProvincesList] = useState([]);
  const [cantonList, setCantonList] = useState([]);
  const [parroquiaList, setParroquiaList] = useState([]);

  const [resultOk, setResultOk] = useState(false);
  const [resultError, setResultError] = useState(false);

  const [selectedParroqiaObject, setSelectedParroqiaObject] = useState(null);

  const getProvince = useCallback(async () => {
    setProvincesList(await provinces());
  }, []);

  useEffect(() => {
    getProvince();
  }, []);

  const getCantonByProvince = useCallback(async () => {
    setCantonList(await cantonsByProvince(selectedProvinceEdit));
  }, [selectedProvinceEdit]);

  useEffect(() => {
    getCantonByProvince();
  }, [selectedProvinceEdit]);

  const getParroquiaByCanton = useCallback(async () => {
    setParroquiaList(await parroquiasByCanton(selectedCantonEdit));
  }, [selectedCantonEdit]);

  useEffect(() => {
    getParroquiaByCanton();
  }, [selectedCantonEdit]);

  useEffect(() => {
    const _obj = parroquiaList.filter((elem) => {
      return elem.idParish === selectedParroquiaEdit;
    });
    setSelectedParroqiaObject(_obj ? _obj[0] : null);
  }, [selectedParroquiaEdit]);

  return (
    <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1}>
      <Grid container>
        <Grid item md={4} xs={12} padding={1}>
          <CommonSelectWithoutNoneOption
            defaultValue={selectedProvinceEdit}
            label="Provincia"
            data={provincesList.map((e) => {
              return { id: e.idProvince, name: e.name };
            })}
            onChange={(selectedValue) => setSelectedProvinceEdit(selectedValue)}
          ></CommonSelectWithoutNoneOption>
        </Grid>
        <Grid item md={4} xs={12} padding={1}>
          <CommonSelectWithoutNoneOption
            defaultValue={selectedCantonEdit}
            label="Cantón"
            data={cantonList.map((e) => {
              return { id: e.idCanton, name: e.name };
            })}
            onChange={(selectedValue) => setSelectedCantonEdit(selectedValue)}
          ></CommonSelectWithoutNoneOption>
        </Grid>
        <Grid item md={4} xs={12} padding={1}>
          <CommonSelectWithoutNoneOption
            defaultValue={selectedParroquiaEdit}
            label="Parroquia"
            data={parroquiaList.map((e) => {
              return { id: e.idParish, name: e.name };
            })}
            onChange={(selectedValue) => setSelectedParroquiaEdit(selectedValue)}
          ></CommonSelectWithoutNoneOption>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item sm={6} xs={12} padding={1}>
          <MDInput
            variant="outlined"
            type="text"
            label="Codigo"
            value={code}
            fullWidth={true}
            onChange={(event) => setCode(event.target.value)}
            success={code != ""}
            error={code === ""}
          />
        </Grid>
        <Grid item sm={6} xs={12} padding={1}>
          <MDInput
            variant="outlined"
            type="text"
            label="Identificador"
            value={identifier}
            fullWidth={true}
            onChange={(event) => setIdentifier(event.target.value)}
            success={identifier != ""}
            error={identifier === ""}
          />
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={6} xs={12} padding={1}>
          <MDInput
            variant="outlined"
            type="text"
            label="Nombre Comercial"
            value={businessName}
            fullWidth={true}
            onChange={(event) => setBusinessName(event.target.value)}
            success={businessName != ""}
            error={businessName === ""}
          />
        </Grid>
        <Grid item sm={6} xs={12} padding={1}>
          <MDInput
            variant="outlined"
            type="text"
            label="Área"
            value={areaName}
            fullWidth={true}
            onChange={(event) => setAreaName(event.target.value)}
            success={areaName != ""}
            error={areaName === ""}
          />
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={6} xs={12} padding={1}>
          <MDInput
            variant="outlined"
            type="text"
            label="Representante Legal"
            value={legalRepresentative}
            fullWidth={true}
            onChange={(event) => setLegalRepresentative(event.target.value)}
            success={legalRepresentative != ""}
            error={legalRepresentative === ""}
          />
        </Grid>
        <Grid item sm={6} xs={12} padding={1}>
          <MDInput
            variant="outlined"
            type="text"
            label="Representante Técnico"
            value={technicalRepresentative}
            fullWidth={true}
            onChange={(event) => setTechnicalRepresentative(event.target.value)}
            success={technicalRepresentative != ""}
            error={technicalRepresentative === ""}
          />
        </Grid>
      </Grid>

      <Grid container>
        <Grid item sm={6} xs={12} padding={1}>
          <MDInput
            variant="outlined"
            type="text"
            label="Dirección"
            value={address}
            fullWidth={true}
            onChange={(event) => setAddress(event.target.value)}
            success={address != ""}
            error={address === ""}
          />
        </Grid>
        <Grid item sm={6} xs={12} padding={1}>
          <MDInput
            variant="outlined"
            type="text"
            label="Referencia"
            value={reference}
            fullWidth={true}
            onChange={(event) => setReference(event.target.value)}
            success={reference != ""}
            error={reference === ""}
          />
        </Grid>
      </Grid>

      <br></br>
      {resultOk ? (
        <Alert
          severity="success"
          onClose={() => {
            setResultOk(false);
          }}
        >
          Almacen actualizado exitosamente
        </Alert>
      ) : (
        <div></div>
      )}
      {resultError ? (
        <Alert
          severity="error"
          onClose={() => {
            setResultError(false);
          }}
        >
          Lo sentimos no se ha podido actualizar el almacen
        </Alert>
      ) : (
        <div></div>
      )}

      <Grid container marginTop={2}>
        <Grid item padding={2}>
          <MDButton variant="outlined" color="info" onClick={() => setIsHandlingWarehouse(false)}>
            Atras
          </MDButton>
        </Grid>
        {elementToEdit ? (
          <Grid item padding={2}>
            <MDButton
              variant="contained"
              color="info"
              onClick={() =>
                edit(
                  elementToEdit.id,
                  code,
                  identifier,
                  businessName,
                  areaName,
                  legalRepresentative,
                  technicalRepresentative,
                  address,
                  reference,
                  selectedParroquiaEdit,
                  selectedCantonEdit,
                  elementToEdit.parish,
                  setResultOk,
                  setResultError
                )
              }
            >
              Actualizar
            </MDButton>
          </Grid>
        ) : (
          <Grid item padding={2}>
            <MDButton
              disabled={false}
              variant="contained"
              color="info"
              onClick={() =>
                add(
                  code,
                  identifier,
                  businessName,
                  areaName,
                  legalRepresentative,
                  technicalRepresentative,
                  address,
                  reference,
                  selectedParroquiaEdit,
                  selectedCantonEdit,
                  selectedParroqiaObject.createdDate,
                  selectedParroqiaObject.modifiedDate,
                  selectedParroqiaObject.name,
                  selectedParroqiaObject.code,
                  setResultOk,
                  setResultError
                )
              }
            >
              Adicionar
            </MDButton>
          </Grid>
        )}
      </Grid>
    </MDBox>
  );
}
HandleWarehouse.defaultProps = {
  elementToEdit: null,
  setIsHandlingWarehouse: null,
};

HandleWarehouse.propTypes = {
  elementToEdit: PropTypes.object,
  setIsHandlingWarehouse: PropTypes.func,
};

export default HandleWarehouse;
